// Values for dtoIn for requesting values to the table
export const FILTER_BY_EMAIL = "email";

export const REG_EX_CHARACTERS_IN_EMAIL = /^[\w-+@.]+$/;
